import { ApolloProviderV4 } from '~/apollo/client-v4';
import { PageHeading } from '~/components/common/PageHeading';
import { useBreadcrumb } from '~/components/layout/Breadcrumb';
import { CreatePaleoMapForm } from '~/components/upload/paleomap/create-paleomap-form';
import { UploadPaleoMapNavigation } from '~/routes/upload/paleomap/$paleoMapId/__PaleoMapNavigation';

export default function UploadPaleomapCreatePage() {
  return (
    <ApolloProviderV4>
      <PageInner />
    </ApolloProviderV4>
  );
}

function PageInner() {
  useBreadcrumb('routes/upload/paleomap/create', 'Create Palaeomap');

  return (
    <div className="space-y-4">
      <PageHeading>Create Palaeomap</PageHeading>

      <UploadPaleoMapNavigation id={-1} disabled />

      <div className="grid lg:grid-cols-2 gap-4">
        <CreatePaleoMapForm />
        <div />
      </div>
    </div>
  );
}
